import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import PageHeader from "../components/PageHeader";
import Button from "../components/Button";
import OperatorCard from "../components/OperatorCard";
import OperatorModal from "../components/OperatorModal";
import OperatorPaymentPanel from "../components/OperatorPaymentPanel";
import SearchBar from "../components/SearchBar";

import operatorService from "../services/operatorService";

function Operators() {
  const [searchParams] = useSearchParams();
  const [operators, setOperators] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [financialSummary, setFinancialSummary] = useState({});
  const [summaryError, setSummaryError] = useState("");
  const [paymentOperator, setPaymentOperator] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadOperators();
    loadFinancialSummary();
  }, []);

  useEffect(() => {
    if (searchParams.get("action") === "create") handleCreate();
  }, [searchParams]);

  const loadOperators = async () => {
    try {
      const data = await operatorService.getAll();
      setOperators(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadFinancialSummary = async () => {
    try {
      const summary = await operatorService.getFinancialSummary();
      setFinancialSummary(Object.fromEntries(summary.map((item) => [item.operador._id, item])));
      setSummaryError("");
    } catch (error) {
      setFinancialSummary({});
      setSummaryError("No se pudieron cargar las comisiones. Reintentá la consulta.");
    }
  };

  const handleCreate = () => {
    setSelectedOperator(null);
    setOpenModal(true);
  };

  const handleEdit = (operator) => {
    setSelectedOperator(operator);
    setOpenModal(true);
  };

  const handleDelete = async (operator) => {
    if (
      !window.confirm(
        `¿Eliminar al operador ${operator.nombre} ${operator.apellido}?`
      )
    )
      return;

    try {
      await operatorService.remove(operator._id);
      loadOperators();
    } catch (error) {
      alert(error.response?.data?.error || "Error al eliminar");
    }
  };

  const handleSave = async (form) => {
    try {
      if (selectedOperator) {
        await operatorService.update(selectedOperator._id, form);
      } else {
        await operatorService.create(form);
      }

      setOpenModal(false);
      loadOperators();
      loadFinancialSummary();
    } catch (error) {
      console.error(error);
      alert("Error al guardar");
    }
  };

  const filteredOperators = operators.filter((operator) =>
    `${operator.nombre} ${operator.apellido} ${operator.telefono} ${operator.email} ${operator.cbuCvu} ${operator.alias}`.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <PageHeader
        title="Operadores"
        subtitle="Administración de operadores"
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 20,
        }}
      >
        <Button onClick={handleCreate}>
          + Nuevo Operador
        </Button>
      </div>

      <SearchBar
        placeholder="Buscar operador, alias o CBU/CVU..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {summaryError && <div role="alert"><p>{summaryError}</p><Button onClick={loadFinancialSummary}>Reintentar</Button></div>}

      <div className="cc-card cc-section-card">
        <div className="cc-list-header cc-operator-header">
          <span>Operador</span><span>Comisión</span><span>Estado</span><span>Acciones</span>
        </div>
        {filteredOperators.length === 0 ? (
          <div className="cc-empty">No hay operadores registrados.</div>
        ) : (
          filteredOperators.map((operator) => (
            <OperatorCard
              key={operator._id}
              operator={operator}
              financial={financialSummary[operator._id]}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onPayments={setPaymentOperator}
            />
          ))
        )}
      </div>

      {paymentOperator && (
        <OperatorPaymentPanel
          key={paymentOperator._id}
          operator={paymentOperator}
          financial={financialSummary[paymentOperator._id]}
          onUpdated={loadFinancialSummary}
        />
      )}

      <OperatorModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSave={handleSave}
        operator={selectedOperator}
      />
    </>
  );
}

export default Operators;
